import { styled } from '@linaria/react';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';
import Aside from '@/components/Aside';
import InlineCode from '@/components/InlineCode';

function OverflowDemo() {
  return (
    <>
      <NoClipSupport>
        <Aside type="warning" title="Unsupported browser detected">
          <p>
            The browser you’re using doesn’t support the{' '}
            <InlineCode>overflow: clip</InlineCode> declaration.
          </p>
          <p>
            Here’s what this demo <em>should</em> look like:
          </p>
          <FallbackImg
            src="/images/browser-support/overflow-clip-fallback.png?v=2"
            width={1454 / 2}
            height={934 / 2}
            loading="lazy"
          />
        </Aside>
      </NoClipSupport>
      <Demo
        initialValues={{
          overflow: 'clip',
        }}
        controlPosition="top"
        customGrid={{ gridTemplateColumns: '1fr' }}
        controls={[
          <DemoToggleButtonGroupControl
            inline
            key="overflow"
            id="overflow"
            label="overflow-x"
            options={[
              {
                value: 'visible',
                label: 'visible (default)',
                shortLabel: 'visible',
              },
              'auto',
              'hidden',
              'clip',
            ]}
          />,
        ]}
      >
        {({ overflow }) => {
          return (
            <OuterWrapper>
              <Wrapper style={{ overflowX: overflow }}>
                <Josh
                  src="/images/josh/josh-happy-light.png"
                  alt="A 3D representation of Josh, rendered in a playful clay style"
                />
              </Wrapper>
            </OuterWrapper>
          );
        }}
      </Demo>
    </>
  );
}

const OuterWrapper = styled.div`
  width: 100%;
  height: 280px;
`;

const Wrapper = styled.div`
  position: relative;
  height: 200px;
  outline: 3px dashed var(--color-primary);
`;

const Josh = styled.img`
  position: absolute;
  top: 32px;
  right: -32px;
  width: 137.5px;
  height: 232px;
  transform: rotate(-20deg);
`;

const NoClipSupport = styled.div`
  @supports (overflow: clip) {
    display: none;
  }
`;
const FallbackImg = styled.img`
  display: block;
  margin-inline: auto;
  margin-top: 16px;
`;

export default OverflowDemo;
